import { Space } from "antd";
import { PublishPermissionContentModal } from "../../../modal/publish-permission-content/publish-permission-content-modal";

export interface DocEditor {
  Id: string;
  date: string;
  displayName: string;
  email: string;
}

interface Props {
  docEditors?: DocEditor[];
  label?: string;
  onSubmit?: (keys: string[], docEditors: DocEditor[], options: { reset: () => void }) => void;
  disabled?: boolean;
}

const DecentralizeContentTitleTable = (props: Props) => {
  const { label, onSubmit = () => {}, disabled } = props;

  return (
    <>
      {label && <div>{label}</div>}
      <Space.Compact block>
        <PublishPermissionContentModal disabled={!!disabled} onConfirm={onSubmit} />
      </Space.Compact>
    </>
  );
};

export default DecentralizeContentTitleTable;
